import i18next from 'i18next';

const getInitialState = function () {
  var state = {
    locale: localStorage.getItem('site_locale') || 'en',
  };
  return state;
};

export default {
  namespaced: true,

  state: getInitialState(),

  getters: {
    getLocale(state) {
      return state.locale;
    },
  },

  mutations: {
    changeLocale(state, locale) {
      state.locale = locale;
      i18next.changeLanguage(locale);
    },
    RESET_STATE:function (state) {
      Object.assign(state, getInitialState())
    }
  },

  actions: {
    setLocale({ commit }, locale) {
      localStorage.setItem('site_locale', locale);
      commit('changeLocale', locale);
    },
  },
};
